module.exports = __webpack_public_path__ + "img/my_bubble_hint@3x.47eebe17.png";